// Product Image Swiper Initialization
document.addEventListener('DOMContentLoaded', function() {
  // 商品画像のSwiperを初期化
  const productSwipers = document.querySelectorAll('.product-swiper');
  
  productSwipers.forEach(swiperElement => {
    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: swiperElement.querySelector('.product-swiper-pagination'),
        clickable: true,
        dynamicBullets: false,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },
      autoplay: false, // 自動スライドはオフ
      speed: 300,
      effect: 'slide',
      // タッチ・マウスでのスライド操作を有効
      touchRatio: 1,
      simulateTouch: true,
      allowTouchMove: true
    });
  });
});